<template></template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { encryptParams } from '../../utils/cryptojs_utils'

export default {
  name: 'Auth',
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['idToken'])
  },
  created () {
    let code = this.$route.query.code
    if (code) {
      let service = window.localStorage.getItem('service')
      this.completeOauth(this.$route.query, service)
    } else {
      let service = this.$route.query.service
      let redirectTo = this.$route.query.redirect_to
      let loginUrl = this.$route.query.loginUrl || ''
      window.localStorage.setItem('service', service)
      window.localStorage.setItem('redirectTo', redirectTo)
      this.redirectToService(service, loginUrl)
    }
  },
  methods: {
    redirectToService (service, loginUrl) {
      Vue.axios.post('/auth/' + service, { 'loginUrl': loginUrl })
        .then(res => {
          if (res.data.link) {
            window.location = res.data.link
          }
        })
    },
    completeOauth (query, service) {
      let payload = {
        'query': JSON.stringify(query),
        'service': service
      }
      Vue.axios.post('/auth/' + service + '/done', payload, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.status === 'success') {
            if (res.data.service === 'salesforce') {
              this.authenticateUser(res)
            } else {
              let redirectTo = window.localStorage.getItem('redirectTo')
              window.localStorage.removeItem('service')
              window.localStorage.removeItem('redirectTo')
              window.location.href = redirectTo
            }
          } else {
            window.localStorage.clear()
            Vue.toasted.show(res.data.msg || this.$t('COMMON.MSG_ERROR'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    authenticateUser (res) {
      let data = new window.FormData()
      data.append('auth[unique_id]', res.data.unique_id)
      Vue.axios.post('/user_token', data)
        .then(res => {
          if (res.data.status === 'created') {
            window.localStorage.setItem('idToken', res.data.token.token)
            window.localStorage.setItem('accountId', encryptParams(res.data.account_id))
            window.localStorage.setItem('accountName', encryptParams(res.data.account_name))
            window.localStorage.setItem('role', res.data.role)
            window.localStorage.setItem('endDate', res.data.end_date)
            window.localStorage.setItem('email', res.data.email)
            window.localStorage.setItem('userId', res.data.user_id)
            window.localStorage.setItem('selectedRoles', JSON.stringify(res.data.selected_roles))
            window.localStorage.setItem('userRoleOrder', res.data.user_role_order)
            window.localStorage.setItem('mode', 'service')
            this.$store.dispatch('autoLogin')
            this.$store.dispatch('setMetaData')
            let redirectTo = window.localStorage.getItem('redirectTo')
            window.localStorage.removeItem('service')
            window.localStorage.removeItem('redirectTo')
            window.location.href = redirectTo
          }
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/auth/Auth.vue